module.exports = {"id":"199247","name":"Álex Fernández","rating":"72","photo":"./data/images/photos/0/199247.png","club":{"name":"Cádiz C.F.","logo":"./data/images/clubs/CadizC.F..png"},"positions":["MDC","MOC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexFernandez0.json
// module id = 207
// module chunks = 0